import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  standalone: true,
  imports: [RouterModule, NgIcon],
  styles: [`
    /* ---- Navigation Item Styles ----
       Uses sidebar CSS variables for consistent theming.
       Isolated from Materialize/Bootstrap link styles. */

    .nav-item {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      padding: 10px 12px;
      border-radius: 8px;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.25;
      color: var(--sidebar-foreground);
      opacity: 0.7;
      text-decoration: none;
      outline: none;
      cursor: pointer;
      transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
    }

    .nav-item:hover {
      background-color: var(--sidebar-accent);
      color: var(--sidebar-accent-foreground);
      opacity: 1;
      text-decoration: none;
    }

    /* Active state — accent background with primary (orange) text */
    .nav-item--active {
      background-color: var(--sidebar-accent);
      color: var(--sidebar-primary);
      opacity: 1;
      font-weight: 600;
    }

    .nav-item--active:hover {
      color: var(--sidebar-primary);
    }

    .nav-item__icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
    }

    .nav-item__label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* Override any global <a> styles from Materialize/Bootstrap */
    :host a,
    :host a:visited,
    :host a:focus {
      text-decoration: none;
      color: inherit;
    }
  `],
})
export class NavItemComponent {
  @Input() icon: string;
  @Input() label: string;
  @Input() routerLink: string | unknown[];
}
